import React, { Fragment } from "react";
import FormControl from "@material-ui/core/FormControl";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useLicenseTypes } from "../../vocabularyServices";
import { Skeleton } from "@material-ui/lab";
import FormHelperText from "@material-ui/core/FormHelperText";
import { anyTrue, notBlank } from "../../../util/ext";
import {
  identity,
  ifElse,
  reject,
  propEq,
  equals,
  is,
  find,
  includes,
} from "ramda";
import { useCurrentOrgId, useIsAdmin } from "../../../auth/authUtils";
import { isBlank } from "../../../util/ext";

const OHIO_LINK_ORG = "ba6600f0-842b-442c-aa5b-8208f2f999fc";
const withoutOhioLinkLicense = reject(propEq("code", "OHIO_LINK_CP"));

const LicenseTypeSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    required = false,
    error = false,
    helperText = "",
  } = props;
  const currentOrgId = useCurrentOrgId();
  const licenseTypes = useLicenseTypes();
  const isAdmin = useIsAdmin();

  return (
    <Fragment>
      {licenseTypes.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <Autocomplete
            id="content-licenseType"
            value={value || ""}
            onChange={onChange}
            options={ifElse(
              () => anyTrue([isAdmin, equals(currentOrgId, OHIO_LINK_ORG)]),
              identity,
              withoutOhioLinkLicense,
            )(licenseTypes.data)}
            getOptionLabel={option => {
              if (isBlank(option)) {
                return "";
              } else if (is(Object, option)) {
                return option.displayName;
              } else {
                const lt = find(
                  lt => includes(option, [lt.id, lt.name, lt.code]),
                  licenseTypes.data,
                );
                return lt?.displayName ?? lt.name;
              }
            }}
            getOptionSelected={(lt, val) => notBlank(val) && lt.id === val.id}
            renderInput={params => {
              params.inputProps["aria-autocomplete"] = "none";
              params.inputProps["id"] = "content-licenseType";
              return (
                <TextField
                  {...params}
                  required={required}
                  error={error}
                  type="text"
                  onBlur={onBlur}
                  name="content-LicenseType"
                  fullWidth
                  label="License Type"
                />
              );
            }}
          />
          {notBlank(error) && (
            <FormHelperText error>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    </Fragment>
  );
};

export default LicenseTypeSelect;
